export default "__VITE_ASSET__CauISjF6__"